import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSunriseArrowUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSunriseArrowUp"><Path d="M2.5 19.5H21.5M12 8.5V4M2.5 16.5H4.5M19.5 16.5H21.5M17.7461 11.1791L19.2782 9.89352M4.72266 9.89351L6.25475 11.1791M9.5 6L12 3.5L14.5 6M7.5 16.5V16C7.5 13.5147 9.51472 11.5 12 11.5C14.4853 11.5 16.5 13.5147 16.5 16V16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSunriseArrowUp;
